import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from '../product.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ControlItem, ProductTypesEnum } from 'src/app/models/frontend';
import { ProductTypeData } from 'src/app/models/enums';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss'],
})
export class CreateProductComponent {
  errors: string[] | null = null;
  eventForm: FormGroup

  currentSelected: {};

  Locations:any
  toppings = new FormControl();
  toppingList: string[] = []; // Example list of toppings

  productType:ControlItem[]=[];
  category:any
  categoryData:ControlItem[]=[]
  skuValue="0"
  options = [
    
  ];
  selectedOptions: string[] = [];

  productImage: File;
  loader=false

  getSelectedOptions() {
    console.log(this.selectedOptions);
    // Do whatever you need with the selected options
  }

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, 
    public productService: ProductService,private toastr:ToastrService) {
      this.LoadLocations()
      this.LoadCategories()
      this.productType=ProductTypesEnum
      console.log(this.productType)
     }

  ngOnInit() {
    this.eventForm = this.fb.group({
      SKU: ['', [Validators.required, Validators.maxLength(100)]],
      ProductName: ['', [Validators.required, Validators.maxLength(100)]],
      Description: ['', [Validators.required, Validators.maxLength(100)]],
      DistributorPrice: ['', [Validators.required, Validators.maxLength(100)]],
      RetailPrice: ['', [Validators.required, Validators.maxLength(100)]],
      Unit: ['', [Validators.required, Validators.maxLength(100)]],
      CategoryId: ['', [Validators.required, Validators.maxLength(10)]],
      TotalStock: ['', [Validators.required, Validators.maxLength(10)]],
      StockSold: ['', [Validators.required, Validators.maxLength(10)]],
      StockRemaining: ['', [Validators.required, Validators.maxLength(10)]],
      ProductType: [null, [Validators.required]],
      LocationIds:['', [Validators.required]]
    });
    this.generateRandomString()
  }
  async onSubmit(skuCode) { 
    this.loader=true
    console.log(this.eventForm.value)
    const productTypeNumber = parseInt(this.eventForm.value.ProductType, 10);
    const retailPriceNumber = parseFloat(this.eventForm.value.RetailPrice);
    const distributorPriceNumber = parseFloat(this.eventForm.value.DistributorPrice);
    const categoryIdNumber = parseInt(this.eventForm.value.CategoryId, 10);
    const TotalStockNumber = parseInt(this.eventForm.value.TotalStock, 10);
    const stockSoldNumber = parseInt("0", 10);
    const stockRemainingNumber = parseInt("0", 10);
   // if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();
  
    this.eventForm = this.fb.group({
      SKU: skuCode,
      ProductName: this.eventForm.value.ProductName,
      Description: this.eventForm.value.Description,
      DistributorPrice: distributorPriceNumber,
      RetailPrice: retailPriceNumber,
      Unit: this.eventForm.value.Unit,
      CategoryId: categoryIdNumber,
      TotalStock: TotalStockNumber,
      StockSold: stockSoldNumber,
      StockRemaining: stockRemainingNumber,
      ProductType:productTypeNumber,
      ImageUrl:'',
      IsActive: true,
    })
    this.eventForm.value.LocationIds=this.selectedOptions
    console.log(this.eventForm.value)
   await this.productService.createProduct(this.eventForm.value)
      .subscribe({
        next: r => {
          console.log(r)
          // Swal.fire('Created', '', 'success')
          this.toastr.success('Created','Success')
          if (this.productImage) this.uploadRafereeImages(r.id);
          this.activeModal.close({ refresh: true });
          this.loader=false
        },
        // error: e => this.errors = e.error?.errors || [e.error?.message]
        error:e=>{
          if(this.errors = e.error?.errors || [e.error?.message])
          {
            this.toastr.error('Oops!', e.error.message);
          }
          else{
            this.toastr.error('Oops!', "Something went wrong");
    
          }
          this.loader=false
        }
      })
  }

  toggleOption(option: string): void {
    const index = this.selectedOptions.indexOf(option);
    console.log(option)
    if (index > -1) {
      this.selectedOptions.splice(index, 1);
    } else {
      this.selectedOptions.push(option);
    }
  }
  LoadLocations(){
    this.productService.getActiveLocations().subscribe((res:any)=>{
      console.log(res)
      this.Locations=res
      for(let i=0;i<=this.Locations.length;i++){
        console.log(this.Locations[i].locationCity)
        this.options.push({value:this.Locations[i].id,viewValue:this.Locations[i].locationCity})
      }
      console.log(this.toppingList)
    })
  }
  LoadCategories(){
    this.productService.getActiveCategories().subscribe((res:any)=>{
      this.category=res
      console.log(this.category)
      for(let i=0;i<=this.category.length;i++){
        console.log(this.category[i].categoryName)
        this.categoryData.push({label:this.category[i].categoryName,value:this.category[i].id})
      }
      console.log(this.categoryData)
    })
  }

  setUserOrPassportImage($event: any) {
    const target = $event.target as HTMLInputElement;
    const files = target.files as FileList;
    const file = files[0];
    this.productImage = file;
  }

  uploadRafereeImages(productId: number) {
    if (!productId || !this.productImage) return this.activeModal.close({ refresh: true });

    let myFormData: FormData = new FormData();
    myFormData.append("ProductId", productId.toString());
    myFormData.append("image", this.productImage, this.productImage.name);

    this.productService.uploadProductImage(myFormData).subscribe({
      next: r => {
        console.log("Image Uploaded ", r);
      },
      error: e => console.log("Image Failed to Upload ", e)
    })
  }

  generateRandomString(){
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < 8; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    this.skuValue=result
  }
}
